import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    /* Remove highlight azul no mobile */
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
  }

  html {
    scroll-behavior: smooth;
    background-color: #0a0a0a;
    background: #0a0a0a;
    /* Otimização de performance para animações */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
    background-color: #0a0a0a;
    background: #0a0a0a;
    color: #fafafa;
    line-height: 1.6;
    overflow-x: hidden;
    position: relative;
    margin: 0;
    padding: 0;
    /* Remove highlight azul no mobile */
    -webkit-tap-highlight-color: transparent;
  }

  /* Prevent any flash */
  #root {
    background: #0a0a0a;
    min-height: 100vh;
    position: relative;
    /* Removido contain que pode interferir com position: fixed */
  }

  /* Scrollbar customizada com animação */
  ::-webkit-scrollbar {
    width: 8px;
    transition: width 0.3s ease;
  }

  ::-webkit-scrollbar-track {
    background: rgba(10, 10, 10, 0.8);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #333, #555);
    border-radius: 4px;
    transition: all 0.3s ease;
    box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.3);
  }

  ::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #444, #666);
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.4);
  }

  /* Otimizações globais para animações - apenas quando usuário permite movimento */
  @media (prefers-reduced-motion: no-preference) {
    [data-animate] {
      will-change: transform, opacity;
      transform: translateZ(0);
      backface-visibility: hidden;
    }

    .smooth-animate {
      transition: all 0.4s cubic-bezier(0.25, 0.1, 0.25, 1);
      will-change: transform, opacity;
    }

    .blur-animate {
      will-change: filter, transform;
      transform: translateZ(0);
    }

    .shadow-animate {
      will-change: box-shadow, transform;
      transform: translateZ(0);
    }

    .gradient-animate {
      will-change: background, transform;
      transform: translateZ(0);
      backface-visibility: hidden;
    }

    .multi-animate {
      will-change: transform, opacity, filter, box-shadow;
      transform: translateZ(0);
      backface-visibility: hidden;
    }
  }

  /* Prevenção de flicker em animações - sempre aplicado */
  .animate-container {
    contain: layout style paint;
    transform: translateZ(0);
  }

  .scroll-animate {
    contain: layout style paint;
    transform: translateZ(0);
    backface-visibility: hidden;
    perspective: 1000px;
  }

  .blur-optimized {
    transform: translateZ(0);
    backface-visibility: hidden;
  }

  .no-repaint {
    contain: layout style paint;
    transform: translateZ(0);
  }

  /* Desabilitar animações para quem prefere movimento reduzido */
  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }

    [data-animate],
    .smooth-animate,
    .blur-animate,
    .shadow-animate,
    .gradient-animate,
    .multi-animate {
      will-change: auto;
      animation: none !important;
      transition: none !important;
    }
  }
`;
